module.exports = __webpack_public_path__ + "img/1825238600611532802.016a17f8.png";